"use client";

import { c as _c } from "react/compiler-runtime";
import { ScrollToTopButton as BaseScrollToTopButton } from "@/components/scroll-to-top-button";
import { useScrollToTop } from "./scroll-to-top-provider";
export function ScrollToTopButton() {
  const $ = _c(3);
  const {
    scrollToTop,
    scrollToTopRef
  } = useScrollToTop();
  const t0 = scrollToTopRef ?? undefined;
  let t1;
  if ($[0] !== scrollToTop || $[1] !== t0) {
    t1 = <BaseScrollToTopButton onScrollToTop={scrollToTop} targetRef={t0} />;
    $[0] = scrollToTop;
    $[1] = t0;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}